import * as R from "ramda";

import { createSelector } from "reselect";
import { getters } from "Portal/NewPortal/PortalHome/model";
import { getFontCssName, resolveFontCss } from "utils/resolve-font-css";

/**
 * Styles
 */
export const getLogoImageUrl = createSelector(
  getters.styles,
  R.prop("logo_image_url")
);
export const getBackgroundImageUrl = createSelector(
  getters.styles,
  R.prop("background_image_url")
);
export const getLogoImageAltText = createSelector(
  getters.styles,
  R.prop("logo_alt_text")
);
export const getBackgroundImageAltText = createSelector(
  getters.styles,
  R.prop("background_image_url_alt_text")
);
export const getEnableBackgroundFullWidth = createSelector(
  getters.styles,
  R.prop("enable_background_full_width")
);
export const getButtonColor = createSelector(
  getters.styles,
  R.prop("button_color")
);
export const getButtonTextColor = createSelector(
  getters.styles,
  R.prop("button_text_color")
);
export const getBackgroundColor = createSelector(
  getters.styles,
  R.prop("background_color")
);
export const getPortalNameFont = createSelector(
  getters.styles,
  R.compose(getFontCssName, R.prop("portal_name_font"))
);
export const getPortalNameSize = createSelector(
  getters.styles,
  R.compose(size => (size ? `${size}px` : null), R.prop("portal_name_size"))
);
export const getPortalNameColor = createSelector(
  getters.styles,
  R.prop("portal_name_color")
);
export const getSectionHeaderFont = createSelector(
  getters.styles,
  R.compose(getFontCssName, R.prop("section_header_font"))
);
export const getSectionHeaderSize = createSelector(
  getters.styles,
  R.compose(size => (size ? `${size}px` : null), R.prop("section_header_size"))
);
export const getSectionHeaderColor = createSelector(
  getters.styles,
  R.prop("section_header_color")
);
export const getAccentColor = createSelector(
  getters.styles,
  R.prop("accent_color")
);

export const getCssCode = createSelector(getters.styles, styles => {
  let css = "";

  const fonts = R.compose(
    R.uniq,
    R.filter(f => f)
  )([styles.portal_name_font, styles.section_header_font]);

  const fontCss = resolveFontCss({ fonts });
  if (fontCss && fontCss.length) {
    css = `${fontCss}`;
  }

  // accent
  css = `${css} 
  /** accentable primary button */
  .accentable-primary-button {
    background-color: ${styles.accent_color};
    border-color: ${styles.accent_color};
  }
  .accentable-primary-button:hover {
    background-color: ${styles.accent_color};
    border-color: ${styles.accent_color};
    filter: brightness(85%);
  }

  /** accentable tab */
  .accentable-tab:hover {
    color: ${styles.accent_color};
  }
  .accentable-tab.active-tab {
    border-color: ${styles.accent_color};
    color: ${styles.accent_color};
  }

  /** accentable generic hover */
  .accentable-hover:hover {
      border: 1px solid ${styles.accent_color};
  }
  /** accentable generic border */
  .accentable-border-with-hover  {
      border: 1px solid ${styles.accent_color};
  }
  .accentable-border-with-hover:hover  {
      border: 1px solid ${styles.accent_color};
  }


  /** accentable text */
  .accentable-text {
      color: ${styles.accent_color};
  }

      
`;

  if (styles.css_code && styles.css_code.length) {
    css = `${css} 
  
  ${styles.css_code}`;
  }

  return css;
});
